/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Reimbursement } from './Reimbursement'

export class Dmpp {
  constructor(json: JSON | any) {
    Object.assign(this as Dmpp, json)
  }

  id?: string
  from?: number
  to?: number
  deliveryEnvironment?: Dmpp.DeliveryEnvironmentEnum
  code?: string
  codeType?: Dmpp.CodeTypeEnum
  price?: string
  cheap?: boolean
  cheapest?: boolean
  reimbursable?: boolean
  reimbursements?: Array<Reimbursement>
  productId?: string
}
export namespace Dmpp {
  export type DeliveryEnvironmentEnum = 'P' | 'A' | 'H' | 'R'
  export const DeliveryEnvironmentEnum = {
    P: 'P' as DeliveryEnvironmentEnum,
    A: 'A' as DeliveryEnvironmentEnum,
    H: 'H' as DeliveryEnvironmentEnum,
    R: 'R' as DeliveryEnvironmentEnum,
  }
  export type CodeTypeEnum = 'CNK' | 'PSEUDO'
  export const CodeTypeEnum = {
    CNK: 'CNK' as CodeTypeEnum,
    PSEUDO: 'PSEUDO' as CodeTypeEnum,
  }
}
